<template>
  <div>
    <transition name="modal">
      <div class="modal-mask eh-popup-overlay">
        <div class="modal-wrapper">
          <div class="modal-container eh-popup-panel">
            <div class="preview">
              <iframe
                :src="viewer"
                class="iframe"
                :id="'extraction-preview'"
                ref="previewFrame"
              ></iframe>
            </div>

            <div class="modal-footer">
              <button class="modal-default-button btn" @click="$emit('close')">
                Close
              </button>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import { PDF_VIEWER_ADDRESS } from "@/api/config";
import EventBus from "../../../event-bus";
export default {
  name: "extraction-preview",
  props: {
    preview: null,
  },
  data() {
    return {
      viewer: PDF_VIEWER_ADDRESS,
    };
  },
  mounted() {
    EventBus.on("refreshMessage", (event) => {
      if (this.preview !== null) {
        this.refreshData(this.preview);
      }
    });
  },
  beforeDestroy() {
    EventBus.off("refreshMessage");
  },
  methods: {
    refreshData(preview) {
      if (preview !== null) {
        // To this origin only, as PdfDoc.vue posts.
        this.$refs["previewFrame"].contentWindow.postMessage({ pdf: preview }, window.location.origin);
      }
    },
  },
  watch: {
    preview(newPreview, old) {
      this.refreshData(newPreview);
    },
  },
};
</script>

<style scoped lang="scss">
.iframe {
  width: 100%;
  height: 100%;
}
.modal-mask {
  /* Backdrop color + z-index from brand-ds (.eh-popup-overlay / --eh-popup-*). */
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: table;
  transition: opacity 0.3s ease;
}

.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}

.modal-container {
  /* Surface, border, radius from brand-ds (.eh-popup-panel / --eh-popup-*). */
  width: 600px;
  margin: 0 auto;
  padding: 20px;
  transition: all 0.3s ease;
}

.modal-footer {
  padding-bottom: 0;
}
.preview {
  margin: 0 auto;
  height: 80vh;
  overflow: scroll;
}

.preview__list {
  list-style-type: none;
  padding-left: 0;

  .p__list__item {
    text-align: center;

    .item--img {
      border-radius: 3px;
      max-width: 100%;
      box-shadow: 0 0 0 1px hsla(0, 0%, 0%, 0.3);
      opacity: 1;
      border: 5px solid lighten(#000000, 90%);
      margin-bottom: 10px;
    }

    .item--desp {
      font-size: 12px;
    }
  }
}

.btn:hover {
  background-color: darken(#ffffff, 50%);
}
</style>
